export const track = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    // tracking must never break the app
  }
};

const sentLeads = new Set();

// Fires generate_lead ONLY after a durable server-accepted save. No PII — lead_type,
// server id and non-personal context only. Deduped per lead id; never fired on failure/retry.
export const trackLead = (leadType, leadId, params = {}) => {
  try {
    const key = `${leadType}:${leadId || ''}`;
    if (leadId && sentLeads.has(key)) return;
    if (leadId) sentLeads.add(key);
    const payload = { lead_type: leadType, ...(leadId ? { lead_event_id: leadId } : {}), ...params };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'generate_lead', ...payload });
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', payload);
  } catch (e) {
    // tracking must never break the app
  }
};
